import PortfolioHero from "./PortfolioHero";
import PortfolioProjectCard from "./PortfolioProjectCard";

const Portfolio = () => {
  return (
    <>
      <PortfolioHero />
      <PortfolioProjectCard />
    </>
  );
};

export default Portfolio;
